<script lang="ts">
  import {goto} from '$app/navigation';
  import {browser} from '$app/environment';

  import {getParameterizedRoute} from '$lib/utils/routes';
  import {Route} from '$lib/enums/routes';

  import {authService} from '$lib/stores/auth';

  $: route = $authService.matches('authd') ? Route.Dashboard : Route.Login;
  $: if (browser) {
    goto(getParameterizedRoute(route));
  }
</script>
